require('leaflet');
require('leaflet.control.opacity');
require('./_leaflet.tilelayer.wmts.min');
require('./_map-legend')

let map;
let maxZoom = 14;
let minZoom = 2;
// let baseUrl = "http://worldcover2020.go.esa.int:8080/geoserver/gwc/service/wmts";
// let baseUrl = "http://worldcover2020.go.esa.int:8080/geoserver/esa_worldcover2020/wms";
let baseUrl = "http://worldcover2020.esa.int:8080/geoserver/gwc/service/wms";
let baseWMTSUrl = "http://worldcover2020.esa.int:8080/geoserver/gwc/service/wms";

/**
 * WMTS

 let wmsWorldCover2020 = L.tileLayer.wmts(baseUrl, {
  layer: 'esa_worldcover2020:tiles',
  format: 'image/png',
  transparent: 'true',
  tileMatrix: 'EPSG:4326',
  tileMatrixSet: 'EPSG:4326',
  maxZoom: maxZoom,
  minZoom: minZoom,
  attribution: '&copy; ESA WorldCover project 2020 / Contains modified Copernicus Sentinel data (2020) processed by ESA WorldCover consortium',
  version: '1.0.0',
  width: '256',
  height: '256',
  tiled: 'true',
  style: 'raster',
});
 */

/**
 * WMS
 */

let wmsWorldCover2020 = L.tileLayer.wms(baseUrl, {
  layers: 'esa_worldcover2020:tiles',
  format: 'image/png',
  transparent: 'true',
  crs: L.CRS.EPSG4326,
  maxZoom: maxZoom,
  minZoom: minZoom,
  attribution: '&copy; ESA WorldCover project 2020 / Contains modified Copernicus Sentinel data (2020) processed by ESA WorldCover consortium',
  version: '1.1.1',
  width: '256',
  height: '256',
});

function init() {
  map = L.map('fp-custom-map').setView([0, 0], minZoom);
  addMapLayersControl();
  handleEvents();

  L.control.mapLegend({ position: 'bottomright', text: 'Toggle legend' }).addTo(map);
}

function handleEvents() {
  map.on('click', onMapClick);
}

function onMapClick(e) {
  getFeatureInfo(e);
}

function addMapLayersControl() {

  // OpenStreetMap layer
  let osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: maxZoom,
    minZoom: minZoom,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  });

  // Google Satellite layer
  let gSat = L.tileLayer('https://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
    maxZoom: maxZoom,
    minZoom: minZoom,
    attribution: '&copy; <a href="https://www.google.com/intl/en_nl/help/terms_maps.html">Google</a>',
  });

  // Google map layer
  let gMap = L.tileLayer('https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}', {
    maxZoom: maxZoom,
    minZoom: minZoom,
    attribution: '&copy; <a href="https://www.google.com/intl/en_nl/help/terms_maps.html">Google</a>',
  });

  let baseMaps = {
    'OpenStreetMap': osm,
    'Google Earth': gSat,
    'Google Maps': gMap,
  };

  let overlayMaps = {
    "World Cover opacity": wmsWorldCover2020
  };

  L.control.layers(baseMaps, overlayMaps).addTo(map);

  // set default base layer
  map.addLayer(osm);

  // set default overlay
  map.addLayer(wmsWorldCover2020);

  // add opacity control
  L.control
    .opacity(overlayMaps)
    .addTo(map);
}

function getFeatureInfo(evt) {
  let url = getFeatureInfoUrl(evt.latlng),
    showResults = L.Util.bind(showGetFeatureInfo, this);
  $.ajax({
    url: url,
    success: function (data, status, xhr) {
      var err = typeof data === 'string' ? null : data;
      showResults(err, evt.latlng, data);
    },
    error: function (xhr, status, error) {
      showResults(error);
    }
  });
}

function showGetFeatureInfo(err, latlng, content) {
  if (err) { console.log(err); return; } // do nothing if there's an error
  let infoBox = document.getElementById('info');

  infoBox.innerHTML = '';
  document.getElementById('info-box').classList.remove("hidden");
  infoBox.innerHTML = '<p>Point: ' + latlng + '</p>' + content;
}

function getFeatureInfoUrl(latlng) {
  let point = map.latLngToContainerPoint(latlng, map.getZoom()),
    size = map.getSize(),
    params = {
      request: 'GetFeatureInfo',
      service: 'WMS',
      srs: 'EPSG:4326',
      style: wmsWorldCover2020.wmsParams.styles,
      transparent: wmsWorldCover2020.wmsParams.transparent,
      version: wmsWorldCover2020.wmsParams.version,
      format: wmsWorldCover2020.wmsParams.format,
      bbox: map.getBounds().toBBoxString(),
      height: size.y,
      width: size.x,
      layers: wmsWorldCover2020.wmsParams.layers,
      query_layers: wmsWorldCover2020.wmsParams.layers,
      info_format: 'text/html'
    };

  params[params.version === '1.3.0' ? 'i' : 'x'] = point.x;
  params[params.version === '1.3.0' ? 'j' : 'y'] = point.y;

  return baseWMTSUrl + L.Util.getParamString(params, baseWMTSUrl, true);
}

if($("#fp-custom-map").length) {
  init();
}
